export default __webpack_public_path__ + "static/media/google-books-search.4cc0bfbc.png";